import { CashRegisterType, CashTransactionType } from "../types/cashRegister";
import { get, post } from "./fetch.core";

interface CashRegisterResponse {
  data: CashRegisterType[];
  message: string;
}

interface CashRegisterTransactionResponse {
  transactions: CashTransactionType[];
}

// export interface LoadCashRegisterParams {
//   paging: {
//     size: number;
//     page: number;
//   };
//   date: {
//     from: string;
//     to: string;
//   };
// }

async function open(data: { openedBy: string }) {
  const res = await post("/pos/cashRegister/open", data);

  return res.data;
}

async function single(id: string) {
  const res = await post<any>(`/pos/cashRegister/single`, { id });

  return res.data;
}

async function startClosing(data: { id: string }) {
  const res = await post("/pos/cashRegister/startClosing", data);

  return res.data;
}

async function close(data: { id: string; closingSummary: string; closedBy: string }) {
  const res = await post("/pos/cashRegister/close", data);

  return res.data;
}

async function list() {
  // if (params.date) {
  //   if (!params.date.from || !params.date.to) delete params.date;
  // }

  const res = await post<CashRegisterResponse>("/pos/cashRegister/list", {});

  return res.data;
}

async function listTransactions(id: string) {
  const res = await get<CashRegisterTransactionResponse>(`/pos/cashRegister/listTransactions/${id}`);

  return res.data;
}

export const posCashRegisterCore = {
  close,
  list,
  listTransactions,
  open,
  single,
  startClosing,
};
